module.exports = __webpack_public_path__ + "img/HZ-S4048.5ccae043.jpg";